<!--
   Created by qing on 2020/2/9 8:04 下午
   Des: 选人组件list区域
-->
<template>

  <van-list
    class="home-list"
    v-if="(depInfo && depInfo.memberList.length) || (depInfo && depInfo.hasSub) || roleList.length || extList.length">
    <div class="divider" v-if="multiple"></div>
    <van-cell v-if="multiple && showMultButton">
      <van-checkbox
        v-model="selectMultiple"
        icon-size="16px"
        @change="multipleChange">
        全选
      </van-checkbox>
    </van-cell>
    <div
      class="divider"
      v-if="showDepList && depInfo.subDepList && depInfo.subDepList.length">
    </div>
    <!--部门-->
    <van-checkbox-group
      v-if="showDepList"
      v-model="selected.dep">
      <van-cell
        v-for="dep in depInfo.subDepList"
        :class="{'cell-disabled' : !multiple && available(availableDeps, disableDep, dep.depId)}"
        :key="dep.depId">
        <!--单选-->
        <div
          v-if="!multiple"
          class="list-item dep-item"
          @click="didSelectDepCell(dep)">
          <div class="left-container">
            <span>{{dep.depName}}</span>
            <span class="member-number">({{dep.subDepList.length}})</span>
          </div>
          <div class="right-container">
            <div class="dep-divider"></div>
            <div class="dep-next" @click.stop="showNextDep(dep)">
              <van-icon name="cluster-o"></van-icon>
              <span>下级</span>
            </div>
          </div>
        </div>
        <!--多选-->
        <div v-else style="width: 100%">
          <van-checkbox
            v-if="showDepCheckbox"
            :disabled="available(availableDeps, disableDep, dep.depId)"
            :name="dep.depId"
            icon-size="16px">
            <div class="list-item dep-item">
              <div class="left-container">
                <span>{{dep.depName}}</span>
                <span class="member-number">({{dep.subDepList.length}})</span>
              </div>
              <div class="right-container">
                <div class="dep-divider"></div>
                <div
                  class="dep-next"
                  @click.stop="showNextDep(dep)">
                  <van-icon name="cluster-o"></van-icon>
                  <span>下级</span>
                </div>
              </div>
            </div>
          </van-checkbox>

          <div
            v-else
            class="list-item dep-item">
            <div class="left-container">
              <span>{{dep.depName}}</span>
              <span class="member-number">({{dep.memberNumber}})</span>
            </div>
            <div class="right-container">
              <div class="dep-divider"></div>
              <div class="dep-next" @click.stop="showNextDep(dep)">
                <van-icon name="cluster-o"></van-icon>
                <span>下级</span>
              </div>
            </div>
          </div>
        </div>
      </van-cell>
    </van-checkbox-group>

    <div
      class="divider"
      v-if="showMemberList && depInfo.memberList && depInfo.memberList.length">
    </div>
    <!--人员-->
    <van-checkbox-group
      v-if="showMemberList"
      v-model="selected.member">
      <van-cell
        v-for="item in depInfo.memberList"
        :class="{'cell-disabled' : !multiple && available(availableMembers, disableMember, item.userId)}"
        :key="item.userId">
        <van-checkbox
          v-if="multiple"
          :name="item.userId"
          :disabled="available(availableMembers, disableMember, item.userId) || Boolean(item.leave && !selected.member.includes(item.userId))"
          icon-size="16px">
          <div class="list-item member-item">
            <van-image
              round
              width="30"
              height="30"
              fit="cover"
              :src="item.headImg">
            </van-image>
            <span>{{item.nickname}}</span>
          </div>
        </van-checkbox>

        <div
          v-else
          class="list-item member-item"
          @click="didSelectMemberCell(item)">
          <van-image
            round
            width="30"
            height="30"
            fit="cover"
            :src="item.headImg">
          </van-image>
          <span>{{item.nickname}}</span>
        </div>
      </van-cell>
    </van-checkbox-group>

    <div
      class="divider"
      v-if="showRoleList && roleList.length">
    </div>
    <!--角色-->
    <van-checkbox-group
      v-if="showRoleList"
      v-model="selected.role">
      <van-cell
        v-for="role in roleList"
        :class="{'cell-disabled' : !multiple && available(availableRoles, disableRole, role.roleCustomId)}"
        :key="role.roleCustomId">
        <van-checkbox
          v-if="multiple"
          :name="role.roleCustomId"
          :disabled="available(availableRoles, disableRole, role.roleCustomId)"
          icon-size="16px">
          <div class="list-item member-item">
            <van-image
              v-if="role.roleIcon"
              round
              width="30"
              height="30"
              fit="cover"
              :src="role.roleIcon">
            </van-image>
            <avatar
              v-else
              style="margin-right: 5px"
              backgroundColor="#FFC107"
              :username="role.roleName"
              :size="30">
            </avatar>
            <span>{{role.roleName}}</span>
          </div>
        </van-checkbox>

        <div v-else class="list-item member-item" @click="didSelectRoleCell(role)">
          <van-image
            v-if="role.roleIcon"
            round
            width="30"
            height="30"
            fit="cover"
            :src="role.roleIcon">
          </van-image>
          <avatar
            v-else
            style="margin-right: 5px"
            backgroundColor="#FFC107"
            :username="role.roleName"
            :size="30">
          </avatar>
          <span>{{role.roleName}}</span>
        </div>
      </van-cell>
    </van-checkbox-group>

    <div
      class="divider"
      v-if="showExtList && extList.length">
    </div>
    <!--外部联系人-->
    <van-checkbox-group
      v-if="showExtList"
      v-model="selected.ext">
      <van-cell
        v-for="ext in extList"
        :class="{'cell-disabled' : !multiple && available(availableExt, disableExt, ext.userId)}"
        :key="ext.userId">
        <van-checkbox
          v-if="multiple"
          :name="ext.userId"
          :disabled="available(availableExt, disableExt, ext.userId) || Boolean(ext.leave && !selected.ext.includes(ext.userId))"
          icon-size="16px">
          <div class="list-item member-item">
            <van-image
              v-if="ext.headImg"
              round
              width="30"
              height="30"
              fit="cover"
              :src="ext.headImg">
            </van-image>
            <avatar
              v-else
              style="margin-right: 5px"
              backgroundColor="#FFC107"
              :username="ext.orgUserName"
              :size="30">
            </avatar>
            <span>{{ext.orgUserName}}</span>
          </div>
        </van-checkbox>

        <div v-else class="list-item member-item" @click="didSelectExtCell(ext)">
          <van-image
            v-if="ext.headImg"
            round
            width="30"
            height="30"
            fit="cover"
            :src="ext.headImg">
          </van-image>
          <avatar
            v-else
            style="margin-right: 5px"
            backgroundColor="#FFC107"
            :username="ext.orgUserName"
            :size="30">
          </avatar>
          <span>{{ext.orgUserName}}</span>
        </div>
      </van-cell>
    </van-checkbox-group>

  </van-list>
  <div v-else class="empty-container">
    <van-icon name="friends-o"/>
    <div>暂无成员</div>
  </div>
</template>

<script>
  import ListContainer from "./ListContainer"
  import Avatar from 'vue-avatar'

  export default {
    props: {
      // 部门对象
      depInfo: Object | null,
      // 选中的人员
      selected: Object | null,
      // 是否显示全选按钮
      showMultButton: {
        type: Boolean,
        default: true
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: true
      },
      // 是否展示人员list
      showMemberList: {
        type: Boolean,
        default: true
      },
      // 是否展示部门list
      showDepList: {
        type: Boolean,
        default: true
      },
      // 是否展示角色list
      showRoleList: {
        type: Boolean,
        default: false
      },
      // 是否展示外部联系人list
      showExtList: {
        type: Boolean,
        default: false
      },

      // 是否展示部门选择框(如果在人员选择页面显示，就不要checkBox，在部门选择页面，需要checkBox，多选单选会单独判读checkBox)
      showDepCheckbox: {
        type: Boolean,
        default: false
      },
      // 角色list
      roleList: {
        type: Array,
        default: () => []
      },
      // 外部联系人list
      extList: {
        type: Array,
        default: () => []
      },

      // 不可选的部门
      disableDep: {
        type: Array,
        default: () => []
      },
      // 不可选的角色
      disableRole: {
        type: Array,
        default: () => []
      },
      // 不可选的人员
      disableMember: {
        type: Array,
        default: () => []
      },
      // 不可选的外部联系人
      disableExt: {
        type: Array,
        default: () => []
      },

      // 部门可选择的 idList
      availableDeps: {
        type: Array,
        default: () => []
      },
      // 成员可选择的 idList
      availableMembers: {
        type: Array,
        default: () => []
      },
      // 角色可选择的 idList
      availableRoles: {
        type: Array,
        default: () => []
      },
      // 外部联系人可选择的 idList
      availableExt: {
        type: Array,
        default: () => []
      },
    },
    components: {
      ListContainer,
      Avatar
    },
    data() {
      return {
        // 是否选中全选
        selectMultiple: false
      };
    },
    methods: {
      available(availableList, disableList, id) {
        if (availableList.length) {
          return !availableList.includes(id)
        } else {
          return disableList.includes(id)
        }
      },
      // 点击子部门
      showNextDep(item) {
        this.$emit('showNextDep', item)
      },
      // 点击选中部门（单选）
      didSelectDepCell(dep) {
        if (this.available(this.availableDeps, this.disableDep, dep.depId)) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectDepCell', dep)
        }
      },
      // 点击选中人员（单选）
      didSelectMemberCell(member) {
        if (this.available(this.availableMembers, this.disableMember, member.userId) || member.leave) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectMemberCell', member)
        }
      },
      // 点击选中角色（单选）
      didSelectRoleCell(role) {
        if (this.available(this.availableRoles, this.disableRole, role.roleCustomId)) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectRoleCell', role)
        }
      },
      // 点击选中外部联系人（单选）
      didSelectExtCell(ext) {
        if (this.available(this.availableExt, this.disableExt, ext.userId) || ext.leave) {
          this.$toast('不可选择')
        } else {
          this.$emit('didSelectExtCell', ext)
        }
      },
      // 全选逻辑处理
      multipleChange() {
        if (this.showMemberList) {
          // 选人员
          let currentMember = this.depInfo.memberList.map(member => member.userId)
            .filter(userId => !this.available(this.availableMembers, this.disableMember, userId))
          if (this.selectMultiple) {
            let arrTmp = []
            arrTmp.push(...this.selected.member)
            arrTmp.push(...currentMember)
            // 去重
            const realIds = Array.from(new Set(arrTmp))
            this.selected.member.splice(0, this.selected.member.length, ...realIds)
          } else {
            let arrTmp = []
            this.selected.member.forEach(userId => {
              if (!currentMember.includes(userId)) {
                arrTmp.push(userId)
              }
            })
            this.selected.member.splice(0, this.selected.member.length, ...arrTmp)
          }
        } else if (this.showDepCheckbox) {
          // 选部门
          let currentDep = this.depInfo.subDepList.map(dep => dep.depId)
            .filter(depId => !this.available(this.availableDeps, this.disableDep, depId))
          if (this.selectMultiple) {
            let arrTmp = []
            arrTmp.push(...this.selected.dep)
            arrTmp.push(...currentDep)
            // 去重
            const realIds = Array.from(new Set(arrTmp))
            this.selected.dep.splice(0, this.selected.dep.length, ...realIds)
          } else {
            let arrTmp = []
            this.selected.dep.forEach(depId => {
              if (!currentDep.includes(depId)) {
                arrTmp.push(depId)
              }
            })
            this.selected.dep.splice(0, this.selected.dep.length, ...arrTmp)
          }
        } else if (this.showRoleList) {
          // 选角色
          let currentRole = this.roleList.map(role => role.roleCustomId)
            .filter(roleCustomId => !this.available(this.availableRoles, this.disableRole, roleCustomId))
          if (this.selectMultiple) {
            let arrTmp = []
            arrTmp.push(...this.selected.role)
            arrTmp.push(...currentRole)
            // 去重
            const realIds = Array.from(new Set(arrTmp))
            this.selected.role.splice(0, this.selected.role.length, ...realIds)
          } else {
            let arrTmp = []
            this.selected.role.forEach(roleCustomId => {
              if (!currentRole.includes(roleCustomId)) {
                arrTmp.push(roleCustomId)
              }
            })
            this.selected.role.splice(0, this.selected.role.length, ...arrTmp)
          }
        } else if (this.showExtList) {
          // 选角色
          let currentExt = this.extList.map(ext => ext.userId)
            .filter(userId => !this.available(this.availableExt, this.disableExt, userId))
          if (this.selectMultiple) {
            let arrTmp = []
            arrTmp.push(...this.selected.ext)
            arrTmp.push(...currentExt)
            // 去重
            const realIds = Array.from(new Set(arrTmp))
            this.selected.ext.splice(0, this.selected.ext.length, ...realIds)
          } else {
            let arrTmp = []
            this.selected.ext.forEach(userId => {
              if (!currentExt.includes(userId)) {
                arrTmp.push(userId)
              }
            })
            this.selected.ext.splice(0, this.selected.ext.length, ...arrTmp)
          }
        }
      }
    }
  };
</script>

<style lang="less">

  .home-list {

    .divider {
      width: 100%;
      height: 10px;
      background-color: #F5F5F5;
    }

    .van-cell {
      /*height: 50px;*/

      .van-cell__value {
        display: flex;
        align-items: center;
      }

      .van-checkbox {
        width: 100%;
        height: 30px;

        .van-checkbox__label {
          width: 100%;
        }
      }
    }

    .cell-disabled {
      background-color: #F5F5F5;
      color: #959699;

      .van-image {
        filter: grayscale(100%);
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
      }

      .van-cell__value--alone {
        color: #959699;
      }
    }

    .list-item {
      display: flex;
      align-items: center;

      .van-image {
        margin-right: 10px;
      }
    }

    .member-item {
      width: 100%;
    }

    .dep-item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left-container {
        flex: 1;
        display: flex;
        align-items: center;

        .member-number {
          color: #91A1B7;
          margin-left: 2px;
        }
      }

      .right-container {
        width: 60px;
        height: 100%;
        display: flex;
        align-items: center;

        .dep-divider {
          width: 1px;
          height: 24px;
          background-color: #ebedf0;
          margin-right: 10px;
        }

        .dep-next {
          display: flex;
          align-items: center;

          .van-icon {
            margin-right: 5px;
            color: #63B2EE;
          }

          span {
            color: #63B2EE;
          }
        }
      }
    }
  }

  .empty-container {
    height: calc(100% - 94px - 44px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #7f828b;

    .van-icon {
      font-size: 60px;
    }
  }

</style>